import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VuePageTransition from 'vue-page-transition'
import ImagesLoaded from 'vue-images-loaded'
import VueResizeText from 'vue-resize-text'
import Flickity from 'vue-flickity'
import Isotope from 'vueisotope'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import MarqueeText from 'vue-marquee-text-component'

Vue.use(VuePageTransition)
Vue.use(VueResizeText)

Vue.directive('images-loaded', ImagesLoaded)

Vue.component('isotope', Isotope)
Vue.component('flickity', Flickity)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.component('marquee-text', MarqueeText)

library.add(far, fal)

const files = require.context('./components/', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
